import { render } from "./AddEditTask.vue?vue&type=template&id=ff8eec7c&scoped=true"
import script from "./AddEditTask.vue?vue&type=script&lang=js"
export * from "./AddEditTask.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./AddEditTask.vue?vue&type=style&index=1&id=ff8eec7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8eec7c"]])

export default __exports__